/**
 * Generate a unique identifier with a given prefix
 * @param {string} prefix - Prefix for the identifier (ex: 'qf' for question filter)
 * @param {string|number} [existingId] - Existing ID to use if available
 * @returns {string} - Unique identifier
 */
export const generateUniqueId = (prefix, existingId = null) => {
  const timestamp = Date.now()
  const randomString = Math.random().toString(36).substring(2, 9)
  const baseId = existingId || timestamp

  return `${prefix}_${baseId}_${randomString}`
}
